import { onValue, ref } from 'firebase/database'
import { useState } from 'react'
import { db } from '../../firebase'

type UseFirebase = {
  onSnapshotExists: (exists: boolean, data: any) => void
}
export const useFirebase = ({ onSnapshotExists }: UseFirebase) => {
  const [notificationNumber, setNotificationNumber] = useState(0)

  const getFirebaseRTDData = (customer) => {
    const query = ref(db, `notifications/${customer}`)
    return onValue(query, (snapshot) => {
      const data = snapshot.val()

      if (snapshot.exists()) {
        const list = Object.entries(data)
        const firstUnChecked = list.find(
          (item: any) => item[1].is_checked === false,
        )
        setNotificationNumber(list.length)

        onSnapshotExists(snapshot.exists(), firstUnChecked[1])
      } else {
        onSnapshotExists(snapshot.exists(), null)
      }
    })
  }

  return {
    getFirebaseRTDData,
    notificationNumber,
    setNotificationNumber,
  }
}
